/**
 * Bot UA 检测正则
 * 涵盖：搜索引擎、社交平台、SEO 工具、监控服务等常见爬虫
 */
const BOT_PATTERN =
  /Googlebot|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|facebookexternalhit|Facebot|Twitterbot|LinkedInBot|Discordbot|TelegramBot|Slackbot|WhatsApp|AhrefsBot|SEMrushBot|MJ12bot|DotBot|PetalBot|Bytespider|UptimeRobot|Pingdom|GTmetrix|HeadlessChrome|PhantomJS|Lighthouse|PageSpeed|bot|crawl|spider|scraper/i;

/** 检测当前 UA 是否是 bot */
export function isBot(): boolean {
  if (typeof navigator === "undefined") return false;
  return BOT_PATTERN.test(navigator.userAgent);
}
